import PropTypes from 'prop-types';
import React from 'react';

import Label from 'components/form/Label';

const InputFieldUploadLabel = ({
  children = null,
  className = '',
  htmlFor = '',
  testId = '',
  ...rest
}) => (
  <Label className={className} htmlFor={htmlFor} testId={testId} {...rest}>
    {children}
  </Label>
);

InputFieldUploadLabel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  htmlFor: PropTypes.string,
  testId: PropTypes.string,
};

export default InputFieldUploadLabel;
